import {
  Component,
  EventEmitter,
  Input,
  Output,
  computed,
  effect,
  signal
} from "@angular/core";
import { Servico } from "@interfaces/service";
import { Store } from "@ngrx/store";
import { selectServices } from "@state/selectors/user.selectors";
import { PaginatorState } from "primeng/paginator";
import {
  formatarCnae,
  formatarItemLc116
} from "src/app/utils/codigos-servico.util";
import { isServicoParametrizado } from "src/app/utils/parametrizacao.util";

@Component({
  selector: "app-service-selector",
  templateUrl: "./service-selector.component.html",
  styleUrls: ["./service-selector.component.scss"]
})
export class ServiceSelectorComponent {
  @Output() closed = new EventEmitter<void>();
  @Output() service = new EventEmitter<Servico>();
  @Input() active = false;
  currentPage = signal(1);
  itemsPerPage = 10;
  // Códigos cada um na sua coluna (quem compara com o portal confere por
  // eles) e a discriminação do cadastro como primeira coluna, para
  // identificar o serviço sem decorar código.
  readonly formatarCnae = formatarCnae;
  readonly formatarItemLc116 = formatarItemLc116;

  private readonly allServices = this.store.selectSignal(selectServices);

  // Pré-cadastros do CNAE (inativos/incompletos) não podem ir para a nota.
  services = computed(() =>
    this.allServices().filter(
      (service) => service.ativo !== false && isServicoParametrizado(service)
    )
  );

  totalServices = computed(() => this.services().length);

  paginatedServices = computed(() => {
    const start = (this.currentPage() - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;

    return this.services().slice(start, end);
  });

  constructor(private readonly store: Store) {
    effect(() => {
      const totalPages = Math.max(
        1,
        Math.ceil(this.totalServices() / this.itemsPerPage)
      );

      if (this.currentPage() > totalPages) {
        this.currentPage.set(totalPages);
      }
    });
  }

  onPageChange(state: PaginatorState) {
    this.currentPage.set((state.page ?? 0) + 1);
  }

  select(service: Servico) {
    this.service.emit(service);
  }
}
